import { PdfExportService } from "app/services/PdfExportService";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { allTrackers } from "app/services/track/track";

export const PngDownload = ({ chartRef, selectedMetricName, offset = { x: 0, y: 0 } }) => {
    const getPNG = (): Promise<void> => {
        allTrackers.trackEvent("Download", "submit-ok", "Bar Chart/Traffic Sources Overview/PNG");
        const styleHTML = PdfExportService.getStylesheetsForPng();
        let height = chartRef?.current?.offsetHeight + 30;
        height = isNaN(height) ? 400 : height;
        const offSetX = 0;
        const offSetY = 50;
        return PdfExportService.downloadHtmlPngFedService(
            styleHTML + chartRef.current.outerHTML,
            selectedMetricName,
            chartRef.current.offsetWidth + offSetX,
            chartRef.current.offsetHeight + offSetY,
        );
    };
    return (
        <DownloadButtonMenu
            PNG={true}
            handleDownloadFunction={getPNG}
        />
    );
};
